import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloudIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cloud"}/>
}
